@charset "UTF-8";

/* src/app/builder-screen-beta/canvas/canvas.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}
.viewmode-hidden {
  display: none !important;
}
.drawer-panel-active {
  position: relative;
  z-index: 10;
  border-left: 4px solid #1890ff;
  box-shadow: 0 2px 12px rgba(24, 144, 255, 0.15);
  border-radius: 8px;
  animation: drawerSlideIn 0.3s ease-out;
}
.drawer-panel-active .panel-container {
  border-color: #1890ff;
}
@keyframes drawerSlideIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.canvas-empty {
  color: #8c8c8c;
  text-align: center;
  padding: 40px;
  font-style: italic;
}
.canvas-controls {
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.canvas-controls button {
  display: flex;
  align-items: center;
  gap: 4px;
}
.canvas-controls .scroll-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.canvas-controls .scroll-controls .component-count {
  font-size: 12px;
  color: #666;
  padding: 0 8px;
  background: #f0f0f0;
  border-radius: 12px;
  min-width: 80px;
  text-align: center;
}
.canvas-controls .scroll-controls button {
  min-width: 28px;
  height: 28px;
}
.canvas-controls .scroll-controls button:hover {
  background: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}
.canvas-scroll-container {
  width: 100%;
  height: auto;
  min-height: 400px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.canvas-scroll-container::-webkit-scrollbar {
  width: 8px;
}
.canvas-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.canvas-scroll-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.canvas-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.canvas-scroll-container.has-many-components {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.canvas-grid-container {
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  gap: 16px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  grid-auto-rows: minmax(60px, auto);
  align-items: stretch;
}
.canvas-grid-container.show-overlay {
  background: #f8f9fa;
}
.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  gap: 16px;
  padding: 16px;
  pointer-events: none;
  z-index: 1;
}
.grid-overlay .grid-cell {
  border: 1px dashed #d9d9d9;
  background: rgba(24, 144, 255, 0.02);
  min-height: 40px;
}
.tab-content-grid {
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  gap: 16px;
  padding: 16px;
  min-height: 200px;
  background: transparent !important;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  grid-auto-rows: minmax(60px, auto);
  align-items: stretch;
}
.canvas-node {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
  transition: all 0.2s ease;
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-image:
    linear-gradient(
      to bottom,
      #fafafa 0%,
      #f5f5f5 100%);
  border-left: 3px solid transparent;
}
.canvas-node[style*=grid-row] {
  border-left-color: rgba(24, 144, 255, 0.3);
}
.canvas-node.is-selected {
  background: #e6f7ff;
  background-image:
    linear-gradient(
      to bottom,
      #e6f7ff 0%,
      #d6efff 100%);
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.canvas-node.child {
  background: #fff;
  background-image:
    linear-gradient(
      to bottom,
      #fff 0%,
      #f8f8f8 100%);
  border-color: #e8e8e8;
}
.component-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 4px;
  justify-content: flex-start;
}
.component-wrapper input,
.component-wrapper textarea,
.component-wrapper nz-input-number,
.component-wrapper nz-switch,
.component-wrapper nz-table {
  width: 100%;
  box-sizing: border-box;
}
.component-wrapper input[nz-input] {
  min-height: 40px;
  flex: 1;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.4;
}
.component-wrapper nz-input-number {
  flex: 1;
  min-height: 40px;
}
.component-wrapper nz-input-number ::ng-deep .ant-input-number {
  height: 100% !important;
  min-height: 40px !important;
}
.component-wrapper nz-input-number ::ng-deep .ant-input-number .ant-input-number-input {
  height: 100% !important;
  padding: 8px 12px !important;
}
.component-wrapper nz-switch {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 40px;
  padding: 8px 0;
}
.component-wrapper textarea {
  flex: 1;
  resize: vertical;
  min-height: 60px;
}
.component-wrapper nz-table {
  flex: 1;
  min-height: 100px;
}
.component-wrapper .node-label {
  margin-bottom: 4px;
  font-weight: 500;
  color: #262626;
  flex-shrink: 0;
}
.component-wrapper .remove-button {
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 10;
  background: #fff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 24px;
  min-height: 24px;
  pointer-events: auto;
}
.component-wrapper .remove-button:hover {
  color: #ff4d4f;
  border-color: #ff4d4f;
  transform: scale(1.05);
}
.component-wrapper .remove-button::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  z-index: -1;
}
.tabs-actions {
  margin-top: 8px;
  text-align: right;
}
.tabs-actions .remove-button {
  background: #fff;
  border: 1px solid #ff4d4f;
}
.tabs-actions .remove-button:hover {
  background: #ff4d4f;
  color: #fff;
}
.tab-close-button {
  margin-left: 8px;
  opacity: 0.6;
  transition: opacity 0.2s;
  position: relative;
  z-index: 1;
}
.tab-close-button:hover {
  opacity: 1;
}
::ng-deep .ant-tabs-tab .tab-close-button {
  vertical-align: middle;
}
::ng-deep .canvas-grid-container .ant-input,
::ng-deep .canvas-grid-container .ant-input-number,
::ng-deep .canvas-grid-container .ant-switch,
::ng-deep .canvas-grid-container .ant-table-wrapper,
::ng-deep .canvas-grid-container .ant-tabs {
  width: 100% !important;
  box-sizing: border-box;
}
::ng-deep .canvas-grid-container .ant-input {
  min-height: 40px !important;
  height: auto !important;
  flex: 1;
}
::ng-deep .canvas-grid-container .ant-input-number {
  display: block;
  height: 100% !important;
  min-height: 40px !important;
}
::ng-deep .canvas-grid-container .ant-input-number .ant-input-number-input {
  height: 100% !important;
  min-height: 40px !important;
}
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table {
  width: 100%;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-content-holder {
  width: 100%;
  background: transparent !important;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-tabpane {
  width: 100%;
  background: transparent !important;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-content {
  background: transparent !important;
}
::ng-deep .canvas-grid-container .ant-tabs .custom-tabset-container,
::ng-deep .canvas-grid-container .ant-tabs nz-tabs.custom-tabset-container {
  background: var(--tabs-container-bg-color, transparent) !important;
  border: 1px solid var(--tabs-container-border-color, transparent) !important;
  border-radius: var(--tabs-container-border-radius, 8px) !important;
  padding: var(--tabs-container-padding, 0) !important;
  transition: all 0.3s ease;
  display: block;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav {
  margin-bottom: 16px !important;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {
  background: var(--content-bg-color, #f5f7fa);
  padding: 4px;
  border-radius: 12px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  background: var(--tab-bg-color, transparent) !important;
  color: var(--tab-text-color, #6b7280) !important;
  border: 1px solid var(--tab-border-color, transparent) !important;
  border-radius: 8px !important;
  margin: 0 4px !important;
  padding: 10px 20px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab::before {
  display: none !important;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  background: var(--active-tab-bg-color, #ffffff) !important;
  color: var(--active-tab-text-color, #1e40af) !important;
  border-color: var(--tab-border-color, rgba(0, 0, 0, 0.08)) !important;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.08),
    0 1px 2px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  font-weight: 600 !important;
  transform: translateY(-1px);
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: inherit !important;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab:hover:not(.ant-tabs-tab-active) {
  background: color-mix(in srgb, var(--tab-bg-color, #ffffff) 70%, var(--active-tab-bg-color, #ffffff) 30%) !important;
  color: var(--active-tab-text-color, #3b82f6) !important;
  border-color: color-mix(in srgb, var(--tab-border-color, transparent) 50%, var(--active-tab-text-color, #3b82f6) 50%) !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
@supports not (background: color-mix(in srgb, white, black)) {
  ::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab:hover:not(.ant-tabs-tab-active) {
    background: rgba(255, 255, 255, 0.6) !important;
  }
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  padding: 0 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  color: inherit !important;
  transition: all 0.3s ease;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-nav .ant-tabs-ink-bar {
  height: 0 !important;
  display: none !important;
}
::ng-deep .canvas-grid-container .ant-tabs .ant-tabs-content-holder {
  background: var(--content-bg-color, transparent) !important;
  color: var(--content-text-color, inherit) !important;
}
::ng-deep .tab-content-grid .ant-input,
::ng-deep .tab-content-grid .ant-input-number,
::ng-deep .tab-content-grid .ant-switch,
::ng-deep .tab-content-grid .ant-table-wrapper,
::ng-deep .tab-content-grid .ant-tabs {
  width: 100% !important;
  box-sizing: border-box;
}
::ng-deep .tab-content-grid .ant-input {
  min-height: 40px !important;
  height: auto !important;
  flex: 1;
}
::ng-deep .tab-content-grid .ant-input-number {
  display: block;
  height: 100% !important;
  min-height: 40px !important;
}
::ng-deep .tab-content-grid .ant-input-number .ant-input-number-input {
  height: 100% !important;
  min-height: 40px !important;
}
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table {
  width: 100%;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-content-holder {
  width: 100%;
  background: transparent !important;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-tabpane {
  width: 100%;
  background: transparent !important;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-content {
  background: transparent !important;
}
::ng-deep .tab-content-grid .ant-tabs .custom-tabset-container,
::ng-deep .tab-content-grid .ant-tabs nz-tabs.custom-tabset-container {
  background: var(--tabs-container-bg-color, transparent) !important;
  border: 1px solid var(--tabs-container-border-color, transparent) !important;
  border-radius: var(--tabs-container-border-radius, 8px) !important;
  padding: var(--tabs-container-padding, 0) !important;
  transition: all 0.3s ease;
  display: block;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav {
  margin-bottom: 16px !important;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {
  background: var(--content-bg-color, #f5f7fa);
  padding: 4px;
  border-radius: 12px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab {
  background: var(--tab-bg-color, transparent) !important;
  color: var(--tab-text-color, #6b7280) !important;
  border: 1px solid var(--tab-border-color, transparent) !important;
  border-radius: 8px !important;
  margin: 0 4px !important;
  padding: 10px 20px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab::before {
  display: none !important;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active {
  background: var(--active-tab-bg-color, #ffffff) !important;
  color: var(--active-tab-text-color, #1e40af) !important;
  border-color: var(--tab-border-color, rgba(0, 0, 0, 0.08)) !important;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.08),
    0 1px 2px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  font-weight: 600 !important;
  transform: translateY(-1px);
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: inherit !important;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab:hover:not(.ant-tabs-tab-active) {
  background: color-mix(in srgb, var(--tab-bg-color, #ffffff) 70%, var(--active-tab-bg-color, #ffffff) 30%) !important;
  color: var(--active-tab-text-color, #3b82f6) !important;
  border-color: color-mix(in srgb, var(--tab-border-color, transparent) 50%, var(--active-tab-text-color, #3b82f6) 50%) !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
@supports not (background: color-mix(in srgb, white, black)) {
  ::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab:hover:not(.ant-tabs-tab-active) {
    background: rgba(255, 255, 255, 0.6) !important;
  }
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  padding: 0 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  color: inherit !important;
  transition: all 0.3s ease;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-nav .ant-tabs-ink-bar {
  height: 0 !important;
  display: none !important;
}
::ng-deep .tab-content-grid .ant-tabs .ant-tabs-content-holder {
  background: var(--content-bg-color, transparent) !important;
  color: var(--content-text-color, inherit) !important;
}
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table .ant-table-thead > tr > th,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table .ant-table-thead > tr > th {
  background-color: var(--table-header-bg, #fafafa) !important;
  color: var(--table-header-color, rgba(0, 0, 0, 0.85)) !important;
  border-color: var(--table-border-color, #f0f0f0) !important;
}
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table .ant-table-tbody > tr > td,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table .ant-table-tbody > tr > td {
  background-color: var(--table-row-bg, #fff) !important;
  color: var(--table-row-color, rgba(0, 0, 0, 0.85)) !important;
  border-color: var(--table-border-color, #f0f0f0) !important;
}
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table .ant-table-tbody > tr:nth-child(even) > td,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table .ant-table-tbody > tr:nth-child(even) > td {
  background-color: var(--table-alt-row-bg, var(--table-row-bg, #fff)) !important;
}
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table .ant-table-tbody > tr:hover > td,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table .ant-table-tbody > tr:hover > td {
  background-color: var(--table-hover-color, #f5f5f5) !important;
}
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table .ant-table-border,
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table.ant-table-bordered .ant-table-thead > tr > th,
::ng-deep .canvas-grid-container .ant-table-wrapper .ant-table.ant-table-bordered .ant-table-tbody > tr > td,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table .ant-table-border,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table.ant-table-bordered .ant-table-thead > tr > th,
::ng-deep .tab-content-grid .ant-table-wrapper .ant-table.ant-table-bordered .ant-table-tbody > tr > td {
  border-color: var(--table-border-color, #f0f0f0) !important;
}
.panel-container {
  border: 2px solid var(--panel-border-color, #d9d9d9);
  border-radius: 6px;
  background: var(--panel-content-bg-color, #fafafa);
  margin: 8px 0;
  transition: all 0.3s ease;
}
.panel-container .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: var(--panel-header-bg-color, rgba(0, 0, 0, 0.03));
  color: var(--panel-header-text-color, inherit);
  border-bottom: 1px solid var(--panel-border-color, #d9d9d9);
  border-radius: 4px 4px 0 0;
  transition: all 0.3s ease;
}
.panel-container .panel-header .panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: inherit;
}
.panel-container .panel-header .panel-title nz-icon {
  color: #1890ff;
}
.panel-container .panel-header .panel-title nz-tag {
  margin-left: 8px;
}
.panel-container .panel-header .panel-controls {
  display: flex;
  gap: 4px;
}
.panel-container .panel-header .panel-controls .collapse-button,
.panel-container .panel-header .panel-controls .remove-button {
  opacity: 0.7;
  transition: opacity 0.2s;
}
.panel-container .panel-header .panel-controls .collapse-button:hover,
.panel-container .panel-header .panel-controls .remove-button:hover {
  opacity: 1;
}
.panel-container .panel-content {
  padding: 16px;
  background: var(--panel-content-bg-color, transparent);
  border-radius: 0 0 4px 4px;
  min-height: 60px;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-auto-rows: minmax(40px, auto);
  gap: 12px;
}
.panel-container .panel-content > [hidden] {
  display: none !important;
}
.panel-container .panel-content .canvas-node.child {
  margin-bottom: 0;
}
.panel-container .panel-drop-zone {
  border: 2px dashed #d9d9d9;
  border-radius: 4px;
  padding: 24px;
  text-align: center;
  color: #8c8c8c;
  transition: all 0.2s;
  cursor: pointer;
}
.panel-container .panel-drop-zone:hover {
  border-color: #1890ff;
  color: #1890ff;
  background: #f6ffed;
}
.panel-container .panel-drop-zone .drop-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.panel-container .panel-drop-zone .drop-placeholder nz-icon {
  font-size: 24px;
}
.panel-container.panel-collapsed .panel-content {
  display: none;
}
.panel-container.panel-active {
  border-color: #1890ff;
}
.panel-container.panel-active .panel-header {
  background: #e6f7ff;
  border-bottom-color: #91d5ff;
}
.panel-container.panel-selected {
  border-color: #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2);
}
.panel-container.panel-selected .panel-header {
  background: #f6ffed;
  border-bottom-color: #b7eb8f;
}
.panel-container.panel-selected .panel-content {
  background: #fcffe6;
}
.panel-container.panel-selected .panel-content::after {
  content: "\271a  " attr(data-add-fields-text);
  display: block;
  text-align: center;
  color: #52c41a;
  font-size: 12px;
  margin-top: 8px;
  padding: 8px;
  border: 1px dashed #52c41a;
  border-radius: 4px;
  background: rgba(82, 196, 26, 0.05);
}
.row-container {
  position: relative;
  margin: 12px 0;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: grid !important;
  grid-template-columns: repeat(24, 1fr);
  grid-auto-rows: minmax(40px, auto);
  gap: 4px;
  padding: 4px;
}
.row-container:hover {
  border-color: #40a9ff !important;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
}
.row-container.row-selected {
  border-color: #52c41a !important;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2);
  background-color: #f6ffed !important;
}
.row-container .row-label {
  position: absolute !important;
  top: -10px;
  left: 8px;
  background: #1890ff;
  color: white;
  padding: 2px 8px;
  font-size: 11px;
  border-radius: 3px;
  z-index: 10;
  pointer-events: none;
}
.row-container .row-child {
  position: relative;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
  min-width: 0;
}
.row-container .row-child .canvas-node.child {
  height: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 8px;
}
.row-container .row-child .canvas-node.child.is-selected {
  outline: 2px solid #1890ff;
  outline-offset: 2px;
  border-radius: 4px;
}
.row-container .row-child .canvas-node.child .component-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.row-container .row-child .canvas-node.child .component-wrapper .node-label {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
}
.row-container .row-child .canvas-node.child .component-wrapper nz-form-item,
.row-container .row-child .canvas-node.child .component-wrapper .ant-form-item {
  margin-bottom: 0;
}
.row-container .row-child .canvas-node.child .component-wrapper input,
.row-container .row-child .canvas-node.child .component-wrapper textarea,
.row-container .row-child .canvas-node.child .component-wrapper nz-input-number,
.row-container .row-child .canvas-node.child .component-wrapper button,
.row-container .row-child .canvas-node.child .component-wrapper nz-select {
  width: 100%;
  box-sizing: border-box;
}
.row-container .row-child .canvas-node.child .component-wrapper input,
.row-container .row-child .canvas-node.child .component-wrapper textarea,
.row-container .row-child .canvas-node.child .component-wrapper nz-input-number,
.row-container .row-child .canvas-node.child .component-wrapper nz-select {
  min-width: 0 !important;
  max-width: 100% !important;
}
.row-container .row-child .canvas-node.child .component-wrapper .ant-input,
.row-container .row-child .canvas-node.child .component-wrapper .ant-input-number,
.row-container .row-child .canvas-node.child .component-wrapper .ant-select {
  box-sizing: border-box !important;
}
.row-container .row-child .canvas-node.child .component-wrapper nz-form-label,
.row-container .row-child .canvas-node.child .component-wrapper .ant-form-item-label {
  padding-bottom: 2px !important;
}
.row-container .row-child .canvas-node.child .component-wrapper .remove-button {
  position: absolute !important;
  top: 2px !important;
  right: 2px !important;
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
  padding: 0 !important;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}
.row-container .row-child .canvas-node.child .component-wrapper .remove-button nz-icon {
  font-size: 10px !important;
}
.row-container .row-child .canvas-node.child .component-wrapper .remove-button:hover {
  background-color: rgba(255, 77, 79, 0.1) !important;
  opacity: 1 !important;
}
.row-container .row-child .canvas-node.child:hover .component-wrapper .remove-button {
  opacity: 0.7;
}
.tab-hidden {
  display: none !important;
}
.tab-visible {
  display: block !important;
}
.tab-content-hidden {
  display: none !important;
}
.tab-content-visible {
  display: block !important;
}
nz-tab {
  transition: opacity 0.3s ease-in-out;
}
nz-tab.tab-hidden {
  opacity: 0;
  pointer-events: none;
}
nz-tab.tab-visible {
  opacity: 1;
  pointer-events: all;
}
.tab-custom-icon {
  width: 14px !important;
  height: 14px !important;
  margin-right: 6px !important;
  vertical-align: middle !important;
  display: inline-block !important;
  object-fit: contain !important;
}
.tab-custom-mat-icon {
  width: 14px !important;
  height: 14px !important;
  margin-right: 6px !important;
  vertical-align: middle !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
}
.tab-custom-mat-icon svg {
  width: 14px !important;
  height: 14px !important;
  display: block !important;
}
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 8px 16px !important;
  background: transparent !important;
}
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn .tab-custom-icon {
  flex-shrink: 0;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  background: transparent !important;
  color: inherit !important;
}
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-nav .ant-tabs-tab:hover:not(.ant-tabs-tab-active) .ant-tabs-tab-btn {
  background: rgba(0, 0, 0, 0.04) !important;
}
nz-tabs .ant-tabs-tab .tab-title-with-icon {
  transition: all 0.3s ease;
}
nz-tabs .ant-tabs-tab .tab-title-with-icon .tab-custom-icon,
nz-tabs .ant-tabs-tab .tab-title-with-icon .tab-theme-icon {
  transition: transform 0.2s ease;
}
nz-tabs .ant-tabs-tab:hover .tab-title-with-icon .tab-custom-icon,
nz-tabs .ant-tabs-tab:hover .tab-title-with-icon .tab-theme-icon {
  transform: scale(1.1);
}
nz-tabs .ant-tabs-tab.ant-tabs-tab-active .tab-title-with-icon {
  font-weight: 600;
}
nz-tabs .ant-tabs-tab.ant-tabs-tab-active .tab-title-with-icon .tab-custom-icon {
  filter: brightness(1.1);
}
::ng-deep nz-tabs .ant-tabs-content-holder,
::ng-deep nz-tabs .ant-tabs-content,
::ng-deep nz-tabs .ant-tabs-tabpane,
::ng-deep nz-tabs .ant-tabs-tabpane-active {
  background: transparent !important;
}
::ng-deep nz-tabs.custom-tabset-container {
  background: var(--tabs-container-bg-color, transparent) !important;
  border: 1px solid var(--tabs-container-border-color, transparent) !important;
  border-radius: var(--tabs-container-border-radius, 8px) !important;
  padding: var(--tabs-container-padding, 0) !important;
  transition: all 0.3s ease;
  display: block;
  box-sizing: border-box;
}
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-content-holder,
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-content,
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-tabpane,
::ng-deep .canvas-grid-container nz-tabs .ant-tabs-tabpane-active,
::ng-deep .tab-content-grid nz-tabs .ant-tabs-content-holder,
::ng-deep .tab-content-grid nz-tabs .ant-tabs-content,
::ng-deep .tab-content-grid nz-tabs .ant-tabs-tabpane,
::ng-deep .tab-content-grid nz-tabs .ant-tabs-tabpane-active {
  background: transparent !important;
}
::ng-deep .canvas-grid-container input,
::ng-deep .canvas-grid-container textarea,
::ng-deep .canvas-grid-container .ant-input,
::ng-deep .canvas-grid-container .ant-input-number-input,
::ng-deep .canvas-grid-container nz-input-number input,
::ng-deep .tab-content-grid input,
::ng-deep .tab-content-grid textarea,
::ng-deep .tab-content-grid .ant-input,
::ng-deep .tab-content-grid .ant-input-number-input,
::ng-deep .tab-content-grid nz-input-number input,
::ng-deep .panel-content input,
::ng-deep .panel-content textarea,
::ng-deep .panel-content .ant-input,
::ng-deep .panel-content .ant-input-number-input,
::ng-deep .panel-content nz-input-number input {
  color: rgba(0, 0, 0, 0.85) !important;
}
::ng-deep .canvas-grid-container input.ant-input-status-error,
::ng-deep .canvas-grid-container input.ant-input-number-status-error,
::ng-deep .canvas-grid-container textarea.ant-input-status-error,
::ng-deep .canvas-grid-container textarea.ant-input-number-status-error,
::ng-deep .canvas-grid-container .ant-input.ant-input-status-error,
::ng-deep .canvas-grid-container .ant-input.ant-input-number-status-error,
::ng-deep .canvas-grid-container .ant-input-number-input.ant-input-status-error,
::ng-deep .canvas-grid-container .ant-input-number-input.ant-input-number-status-error,
::ng-deep .canvas-grid-container nz-input-number input.ant-input-status-error,
::ng-deep .canvas-grid-container nz-input-number input.ant-input-number-status-error,
::ng-deep .tab-content-grid input.ant-input-status-error,
::ng-deep .tab-content-grid input.ant-input-number-status-error,
::ng-deep .tab-content-grid textarea.ant-input-status-error,
::ng-deep .tab-content-grid textarea.ant-input-number-status-error,
::ng-deep .tab-content-grid .ant-input.ant-input-status-error,
::ng-deep .tab-content-grid .ant-input.ant-input-number-status-error,
::ng-deep .tab-content-grid .ant-input-number-input.ant-input-status-error,
::ng-deep .tab-content-grid .ant-input-number-input.ant-input-number-status-error,
::ng-deep .tab-content-grid nz-input-number input.ant-input-status-error,
::ng-deep .tab-content-grid nz-input-number input.ant-input-number-status-error,
::ng-deep .panel-content input.ant-input-status-error,
::ng-deep .panel-content input.ant-input-number-status-error,
::ng-deep .panel-content textarea.ant-input-status-error,
::ng-deep .panel-content textarea.ant-input-number-status-error,
::ng-deep .panel-content .ant-input.ant-input-status-error,
::ng-deep .panel-content .ant-input.ant-input-number-status-error,
::ng-deep .panel-content .ant-input-number-input.ant-input-status-error,
::ng-deep .panel-content .ant-input-number-input.ant-input-number-status-error,
::ng-deep .panel-content nz-input-number input.ant-input-status-error,
::ng-deep .panel-content nz-input-number input.ant-input-number-status-error {
  color: rgba(0, 0, 0, 0.85) !important;
  border-color: #d9d9d9 !important;
}
::ng-deep .canvas-grid-container input:focus,
::ng-deep .canvas-grid-container input:hover,
::ng-deep .canvas-grid-container textarea:focus,
::ng-deep .canvas-grid-container textarea:hover,
::ng-deep .canvas-grid-container .ant-input:focus,
::ng-deep .canvas-grid-container .ant-input:hover,
::ng-deep .canvas-grid-container .ant-input-number-input:focus,
::ng-deep .canvas-grid-container .ant-input-number-input:hover,
::ng-deep .canvas-grid-container nz-input-number input:focus,
::ng-deep .canvas-grid-container nz-input-number input:hover,
::ng-deep .tab-content-grid input:focus,
::ng-deep .tab-content-grid input:hover,
::ng-deep .tab-content-grid textarea:focus,
::ng-deep .tab-content-grid textarea:hover,
::ng-deep .tab-content-grid .ant-input:focus,
::ng-deep .tab-content-grid .ant-input:hover,
::ng-deep .tab-content-grid .ant-input-number-input:focus,
::ng-deep .tab-content-grid .ant-input-number-input:hover,
::ng-deep .tab-content-grid nz-input-number input:focus,
::ng-deep .tab-content-grid nz-input-number input:hover,
::ng-deep .panel-content input:focus,
::ng-deep .panel-content input:hover,
::ng-deep .panel-content textarea:focus,
::ng-deep .panel-content textarea:hover,
::ng-deep .panel-content .ant-input:focus,
::ng-deep .panel-content .ant-input:hover,
::ng-deep .panel-content .ant-input-number-input:focus,
::ng-deep .panel-content .ant-input-number-input:hover,
::ng-deep .panel-content nz-input-number input:focus,
::ng-deep .panel-content nz-input-number input:hover {
  color: rgba(0, 0, 0, 0.85) !important;
}
::ng-deep .canvas-grid-container input.ng-invalid,
::ng-deep .canvas-grid-container input.ng-touched,
::ng-deep .canvas-grid-container input.ng-dirty,
::ng-deep .canvas-grid-container textarea.ng-invalid,
::ng-deep .canvas-grid-container textarea.ng-touched,
::ng-deep .canvas-grid-container textarea.ng-dirty,
::ng-deep .canvas-grid-container .ant-input.ng-invalid,
::ng-deep .canvas-grid-container .ant-input.ng-touched,
::ng-deep .canvas-grid-container .ant-input.ng-dirty,
::ng-deep .canvas-grid-container .ant-input-number-input.ng-invalid,
::ng-deep .canvas-grid-container .ant-input-number-input.ng-touched,
::ng-deep .canvas-grid-container .ant-input-number-input.ng-dirty,
::ng-deep .canvas-grid-container nz-input-number input.ng-invalid,
::ng-deep .canvas-grid-container nz-input-number input.ng-touched,
::ng-deep .canvas-grid-container nz-input-number input.ng-dirty,
::ng-deep .tab-content-grid input.ng-invalid,
::ng-deep .tab-content-grid input.ng-touched,
::ng-deep .tab-content-grid input.ng-dirty,
::ng-deep .tab-content-grid textarea.ng-invalid,
::ng-deep .tab-content-grid textarea.ng-touched,
::ng-deep .tab-content-grid textarea.ng-dirty,
::ng-deep .tab-content-grid .ant-input.ng-invalid,
::ng-deep .tab-content-grid .ant-input.ng-touched,
::ng-deep .tab-content-grid .ant-input.ng-dirty,
::ng-deep .tab-content-grid .ant-input-number-input.ng-invalid,
::ng-deep .tab-content-grid .ant-input-number-input.ng-touched,
::ng-deep .tab-content-grid .ant-input-number-input.ng-dirty,
::ng-deep .tab-content-grid nz-input-number input.ng-invalid,
::ng-deep .tab-content-grid nz-input-number input.ng-touched,
::ng-deep .tab-content-grid nz-input-number input.ng-dirty,
::ng-deep .panel-content input.ng-invalid,
::ng-deep .panel-content input.ng-touched,
::ng-deep .panel-content input.ng-dirty,
::ng-deep .panel-content textarea.ng-invalid,
::ng-deep .panel-content textarea.ng-touched,
::ng-deep .panel-content textarea.ng-dirty,
::ng-deep .panel-content .ant-input.ng-invalid,
::ng-deep .panel-content .ant-input.ng-touched,
::ng-deep .panel-content .ant-input.ng-dirty,
::ng-deep .panel-content .ant-input-number-input.ng-invalid,
::ng-deep .panel-content .ant-input-number-input.ng-touched,
::ng-deep .panel-content .ant-input-number-input.ng-dirty,
::ng-deep .panel-content nz-input-number input.ng-invalid,
::ng-deep .panel-content nz-input-number input.ng-touched,
::ng-deep .panel-content nz-input-number input.ng-dirty {
  color: rgba(0, 0, 0, 0.85) !important;
  border-color: #d9d9d9 !important;
}
::ng-deep .canvas-grid-container .ant-input-number.ant-input-number-status-error,
::ng-deep .tab-content-grid .ant-input-number.ant-input-number-status-error,
::ng-deep .panel-content .ant-input-number.ant-input-number-status-error {
  border-color: #d9d9d9 !important;
}
::ng-deep .canvas-grid-container .ant-input-number.ant-input-number-status-error .ant-input-number-input,
::ng-deep .tab-content-grid .ant-input-number.ant-input-number-status-error .ant-input-number-input,
::ng-deep .panel-content .ant-input-number.ant-input-number-status-error .ant-input-number-input {
  color: rgba(0, 0, 0, 0.85) !important;
}
::ng-deep .canvas-grid-container .ant-input-number .ant-input-number-input,
::ng-deep .tab-content-grid .ant-input-number .ant-input-number-input,
::ng-deep .panel-content .ant-input-number .ant-input-number-input {
  color: rgba(0, 0, 0, 0.85) !important;
}
::ng-deep .canvas-grid-container .ant-form-item-has-error .ant-input,
::ng-deep .canvas-grid-container .ant-form-item-has-error .ant-input-number,
::ng-deep .canvas-grid-container .ant-form-item-has-error textarea,
::ng-deep .tab-content-grid .ant-form-item-has-error .ant-input,
::ng-deep .tab-content-grid .ant-form-item-has-error .ant-input-number,
::ng-deep .tab-content-grid .ant-form-item-has-error textarea,
::ng-deep .panel-content .ant-form-item-has-error .ant-input,
::ng-deep .panel-content .ant-form-item-has-error .ant-input-number,
::ng-deep .panel-content .ant-form-item-has-error textarea {
  color: rgba(0, 0, 0, 0.85) !important;
  border-color: #d9d9d9 !important;
}
::ng-deep .canvas-grid-container .ant-form-item-has-error .ant-form-item-explain-error,
::ng-deep .tab-content-grid .ant-form-item-has-error .ant-form-item-explain-error,
::ng-deep .panel-content .ant-form-item-has-error .ant-form-item-explain-error {
  display: none !important;
}
.builder-image {
  display: block;
  max-width: 100%;
  object-fit: contain;
  transition: transform 0.2s ease;
  background: #f5f5f5;
}
.builder-image:hover {
  transform: scale(1.02);
}
.builder-image[src*="data:image"] {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.context-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background:
    linear-gradient(
      135deg,
      #f0f5ff 0%,
      #e6f0ff 100%);
  border-bottom: 2px solid transparent;
  border-image:
    linear-gradient(
      90deg,
      rgba(24, 144, 255, 0.3) 0%,
      rgba(24, 144, 255, 0.05) 100%) 1;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.08);
  min-height: 40px;
  animation: contextStripFadeIn 0.3s ease-out;
}
.context-strip .context-strip-icon {
  font-size: 14px;
  color: #1890ff;
  opacity: 0.7;
  flex-shrink: 0;
}
.context-strip .context-strip-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}
.context-strip .context-field-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #ffffff;
  border: 1px solid #e8eef7;
  border-radius: 6px;
  padding: 3px 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;
}
.context-strip .context-field-chip:hover {
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.12);
}
.context-strip .context-field-label {
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  white-space: nowrap;
}
.context-strip .context-field-value {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  white-space: nowrap;
}
.context-strip .context-field-separator {
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #d9d9d9;
  margin: 0 4px;
  flex-shrink: 0;
}
@keyframes contextStripFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*# sourceMappingURL=canvas.component.css.map */
